const userMenu = {
  defaultName: "Notandi",
  menu: {
    adminDashboard: "Stjórnborð",
    dataSourcePortal: "Gátt gagnaveitenda",
    browseDatasets: "Skoða gagnasöfn",
    dataRequests: "Beiðnirnar þínar",
    myAccessRequests: "Beiðnir um aðild að verkefni",
    myProjects: "Verkefnin mín",
    backToProjects: "Til baka í verkefni",
  },
};

export default userMenu;
